import { render, staticRenderFns } from "./RunsForCourses.vue?vue&type=template&id=3fc23e10&scoped=true&"
import script from "./RunsForCourses.vue?vue&type=script&lang=ts&"
export * from "./RunsForCourses.vue?vue&type=script&lang=ts&"
import style0 from "./RunsForCourses.vue?vue&type=style&index=0&id=3fc23e10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_@vue+compiler-sfc@3.5.27_babel-core@7.0.0-bridge.0_@babel+core@7.29._fc9feaf815c79c2500a07e12b85cf8ec/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc23e10",
  null
  
)

export default component.exports